<span 
    *ngIf="displayType=='link'" 
    class="customlinkLable" 
    (click)="isNumber(defaultValue) && errRecord()"  
    [style.cursor]="isNumber(defaultValue) ? 'pointer' : 'default'" 
    [style.text-decoration-line]="isNumber(defaultValue) ? 'underline' : 'none'"
    >
    {{ defaultValue }}
</span>
<button 
    mat-raised-button 
    color="primary"  
    *ngIf="displayType=='button'" 
    class="custombuttonLable" 
    (click)="isNumber(defaultValue) && errRecord()" 
    [style.cursor]="isNumber(defaultValue) ? 'pointer' : 'default'" 
    [style.text-decoration-line]="isNumber(defaultValue) ? 'underline' : 'none'" 
    [style.background]="this.color"  
    style="width: 80px;"
    >
    {{defaultValue}}
</button>